import React from 'react';
import Script from 'next/script';
import { Box } from '@zillow/constellation';

var buildRiddleUrl = function buildRiddleUrl(riddleId, staticHeight, lazyImages) {
  var baseUrl = "https://riddle.com/embed/a/" + riddleId;
  var params = new URLSearchParams();
  if (typeof staticHeight !== 'undefined') {
    params.append('staticHeight', staticHeight.toString());
  }
  if (typeof lazyImages !== 'undefined') {
    params.append('lazyImages', lazyImages.toString());
  }
  var queryString = params.toString();
  return queryString ? baseUrl + "?" + queryString : baseUrl;
};
var RiddleEmbed = function RiddleEmbed(_ref) {
  var riddleId = _ref.riddleId,
    _ref$initialHeight = _ref.initialHeight,
    initialHeight = _ref$initialHeight === void 0 ? 400 : _ref$initialHeight,
    staticHeight = _ref.staticHeight,
    lazyImages = _ref.lazyImages;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Script, {
    id: "riddle-embed-script",
    src: "https://riddle.com/embed/build-embedjs/embedV2.js",
    strategy: "afterInteractive"
  }), /*#__PURE__*/React.createElement(Box, {
    className: "riddle2-wrapper",
    sx: {
      margin: '0 auto',
      maxWidth: '100%',
      width: '640px'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: "iframe",
    src: buildRiddleUrl(riddleId, staticHeight, lazyImages),
    allow: "autoplay",
    referrerPolicy: "strict-origin",
    title: "Riddle Embed",
    sx: {
      width: '100%',
      height: initialHeight,
      border: 'none',
      display: 'block'
    }
  })));
};
var RiddleEmbed$1 = RiddleEmbed;

export { RiddleEmbed$1 as default };
